import { render } from "./TitleDiv.vue?vue&type=template&id=6fed646f&scoped=true"
import script from "./TitleDiv.vue?vue&type=script&lang=js"
export * from "./TitleDiv.vue?vue&type=script&lang=js"

import "./TitleDiv.vue?vue&type=style&index=0&id=6fed646f&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fed646f"]])

export default __exports__